(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rh-tt-pass-checkout-button"] && !Shopify.designMode) return;
  try {
    if (window.__rhTtPassCheckoutBound) return;
  window.__rhTtPassCheckoutBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rh-tt-pass-checkout]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    var checkoutUrl = button.getAttribute('data-checkout-url') || '/checkout';
    if (!variantId) return;

    var originalText = button.textContent;
    button.disabled = true;

    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(function (clearResponse) {
        if (!clearResponse.ok) {
          throw new Error('Cart clear failed');
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }]
          })
        });
      })
      .then(function (addResponse) {
        if (!addResponse.ok) {
          throw new Error('Cart add failed');
        }

        window.location.href = checkoutUrl;
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = originalText;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
